import React      from 'react';
import utils      from '../../utils';
import CustomIcon from '../CustomIcon';

import {ResponsiveView, CustomModal, CustomInput, CustomButton2} from '../index';

import './index.sass';
import api from "../../api";

type Props = {
  userName: string;
  wallet?: {
    balance?: number;
    availableFund?: number;
    deptAdmin2Drivers?: number;
    deptCopanies2Admin?: number;
    deptAdmin2Companies?: number;
  }
}

const PrimaryUserInfoAndWallet: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [isOpenModal, setIsOpenModal] = React.useState<boolean>(false);
  const [inputValue , setInputValue ] = React.useState<string>('');
  const [isLoading  , setIsLoading  ] = React.useState<boolean>(false);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  async function request4WithdrawalAdminFromWallet(): Promise<void> {
    await api.get.administrator.adminWithdrawalFromAccount(inputValue);
  }

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleOnClickAvailableFund(): void {
    setIsOpenModal(!isOpenModal);
  }

  function handleOnChangeInputValue(event: React.ChangeEvent<HTMLInputElement>): void {
    setInputValue(event.target.value);
  }

  async function handleOnClickCreateWithdrawal(): Promise<void> {
    setIsLoading(true);
    await request4WithdrawalAdminFromWallet();
    setIsOpenModal(false);
    window.location.reload();
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id='primary-user-info-and-wallet-container'>
      <ResponsiveView.Column medium={9} small={12}>
        <ResponsiveView.Row>
          <ResponsiveView.Column medium={6} large={3} className='custom-box'>
            <div className="user-info-avatar"><i className="fa-solid fa-user"></i></div>
            <div className="user-info-name">{props.userName}</div>
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={5} large={3} className='custom-box green'>
            <CustomIcon
              hoverTitle='پول قابل برداشت'
              onClick={handleOnClickAvailableFund}
              icon='fas fa-square-dollar'
              type='success'
            />
            <span>{`${utils.convertNumberToPrice(Number(props.wallet?.availableFund))} تومان `}</span>
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={4} large={3} className='custom-box blue'>
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'بدهکاری از شرکت‌ها'} type="primary"/>
            <span>{`${utils.convertNumberToPrice(Number(props.wallet?.deptCopanies2Admin))} تومان `}</span>
          </ResponsiveView.Column>
        </ResponsiveView.Row>
      </ResponsiveView.Column>
      <ResponsiveView.Column medium={10} large={8} extraLarge={7}>
        <ResponsiveView.Row className='custom-box'>
          <ResponsiveView.Column medium={4} className='no-wrap'>
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'موحودی کل پول'} type="seconday"/>
            <span>{`${utils.convertNumberToPrice(Number(props.wallet?.balance))} تومان `}</span>
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={4} className='no-wrap'>
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'بدهی ادمین به شرکت‌ها'} type="seconday"/>
            <span>{`${utils.convertNumberToPrice(Number(props.wallet?.deptAdmin2Companies))} تومان `}</span>
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={4} className='no-wrap'>
            <CustomIcon icon="fas fa-credit-card" hoverTitle={'بدهی ادمین به راننده‌ها'} type="seconday"/>
            <span>{`${utils.convertNumberToPrice(Number(props.wallet?.deptAdmin2Drivers))} تومان `}</span>
          </ResponsiveView.Column>
        </ResponsiveView.Row>
      </ResponsiveView.Column>
      <CustomModal
        onClose={handleOnClickAvailableFund}
        open={isOpenModal}
        overlayClose
        label='برداشت از حساب'
        minWidth={'50vw'}
        maxHeight={'40vh'}
      >
        <br />
        <ResponsiveView.Container className='modal-content'>
          <ResponsiveView.Row>
            <ResponsiveView.Column extraLarge={5} large={6} medium={8} small={12} className='custom-box green'>
              <CustomIcon
                hoverTitle='پول قابل برداشت'
                onClick={handleOnClickAvailableFund}
                icon='fas fa-square-dollar'
                type='success'
              />
              <span>{`${utils.convertNumberToPrice(Number(props.wallet?.availableFund))} تومان `}</span>
            </ResponsiveView.Column>
          </ResponsiveView.Row>
          <hr />
          <ResponsiveView.Row>
            <ResponsiveView.Column extraLarge={6} large={12}>
              <CustomInput
                type='number'
                value={inputValue}
                label='مبلغ مورد نظر را واردکنید.'
                onValueChange={handleOnChangeInputValue}
              />
            </ResponsiveView.Column>
          </ResponsiveView.Row>
          <br />
          <ResponsiveView.Row>
            <ResponsiveView.Column medium={6} small={12} style={{marginBottom: '10px'}}>
              <CustomButton2 isLoading={isLoading} title='پرداخت' type='success' onClick={handleOnClickCreateWithdrawal}/>
            </ResponsiveView.Column>
            <ResponsiveView.Column medium={6} small={12}>
              <CustomButton2 isLoading={isLoading} title='لغو' type={'danger'} onClick={handleOnClickAvailableFund}/>
            </ResponsiveView.Column>
          </ResponsiveView.Row>
        </ResponsiveView.Container>
      </CustomModal>
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default PrimaryUserInfoAndWallet;
